import React from "react";

const ModalHeaderLayout = ({ title }) => {
  return <div className="p-5 ">{title}</div>;
};

export default ModalHeaderLayout;
